import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTTooltip, { KTTooltipPositions } from 'general/components/OtherKeenComponents/KTTooltip';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';

DialogWarningThresholdSlotView.propTypes = {
  slotRow: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogWarningThresholdSlotView({ slotRow = {}, onCancel, onDone }) {
  const [loading, setLoading] = useState(false);
  const [tempThreshold, setTempThreshold] = useState('');

  const slotCode =
    slotRow?.slotCode ??
    (slotRow?.slotNumber != null
      ? `Ngăn số ${slotRow.slotNumber}`
      : slotRow?.slotId != null
        ? `SL${String(slotRow.slotId).padStart(8, '0')}`
        : '');

  const checkValidNumberInput = useMemo(() => {
    return (value) => {
      const s = _.toString(value ?? '');
      if (s === '') return true;
      if (s.includes('.') && s.includes(',')) return false;
      return /^\d*([.,]\d*)?$/.test(s);
    };
  }, []);

  const parseNumber = (raw) => {
    const s = _.toString(raw ?? '').trim();
    if (!Utils.isValid(s)) return null;
    return _.toNumber(s.replace(',', '.'));
  };

  const handleSubmit = async () => {
    const iTemp = parseNumber(tempThreshold);

    if (iTemp === null || _.isNaN(iTemp)) {
      ToastHelper.showError('Vui lòng nhập ngưỡng cảnh báo nhiệt độ');
      return;
    }

    setLoading(true);
    try {
      // TODO: gọi API điều chỉnh ngưỡng cảnh báo nhiệt độ ngăn pin khi có API
      ToastHelper.showSuccess('Điều chỉnh ngưỡng cảnh báo nhiệt độ thành công');
      if (onDone) onDone();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="d-flex flex-column align-items-center justify-content-center text-center p-3 gap-2">
        <div className="mb-4">
          <img src={AppResource.vng.vngTemperature} alt="temperature" />
        </div>

        <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])}>
          Điều chỉnh ngưỡng cảnh báo nhiệt độ
        </span>
        <span style={UIHelper.buildFontStyle('400', '14px',undefined, AppColors.gray[600])}>
          Vui lòng nhập ngưỡng cảnh báo nhiệt độ của ngăn pin{' '}
          <span style={UIHelper.buildFontStyle('600', '14px', undefined, AppColors.gray[600])}>{slotCode}</span>.
        </span>

        <div className="w-100 mt-4">
          <div className="text-left">
            <label
              className="d-flex align-items-center mb-1 text-left w-100"
              style={UIHelper.buildFontStyle('700', '13px', AppColors.gray[800])}
            >
              Ngưỡng cảnh báo nhiệt độ&nbsp;
              <span style={{ color: AppColors.danger }}>*</span>
              <KTTooltip
                position={KTTooltipPositions.topStart}
                textHeader="Ngưỡng cảnh báo nhiệt độ"
                text="Khi vượt quá mức nhiệt độ đã thiết lập, hệ thống sẽ thông báo đến nhà điều hành và chuyển nhiệt độ của ngăn pin thành màu đỏ. Lúc này ngăn pin vẫn hoạt động bình thường. "
                isHtmlContent
                offset={[0, 8]}
              >
                <i
                  className="fa-regular fa-circle-info"
                  style={{ color: AppColors.info, marginLeft: 2 }}
                />
              </KTTooltip>
            </label>
            <KTFormInput
              name="tempWarningThreshold"
              placeholder="Nhập số"
              type={KTFormInputType.text}
              unit="°C"
              value={tempThreshold}
              onChange={(value) => setTempThreshold(value)}
              checkValidInput={checkValidNumberInput}
            />
          </div>
        </div>
      </div>

      <div
        className="d-flex align-items-center gap-3 p-3 w-100"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
        {UIHelper.buildGreenButton('Thiết lập', handleSubmit, null, true, loading)}
      </div>
    </div>
  );
}

export default DialogWarningThresholdSlotView;

